/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
window.moment = require('moment');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.Event = new class {

	constructor() {
		this.vue = new Vue();
	}

	fire(event, data = null) {
		this.vue.$emit(event, data);
	}

	listen(event, callback) {
		this.vue.$on(event, callback);
	}
}

const app = new Vue({
    el: '#app',
	data() {
		return {
            cart: null,
            cartcount:0,
            carttotal:0,
		}
	},
	methods: {
		getCart() {
			axios.get('/cart/get').then(response => {
				if(response.data.cart !== undefined) {
					this.cart = response.data.cart;
					this.cartcount = Object.keys(response.data.cart).length;                
					this.carttotal = response.data.total;
				}
			});
		}
	},
	created() {
        let _this = this
        _this.getCart();
		$("#pleaseWaitDialog").modal('hide');
        Event.listen('updateCart',function(){
            _this.getCart();
        });
    }
});
